// extracted by mini-css-extract-plugin
module.exports = {"container":"image-slider_container__10pN4","image":"image-slider_image__1NV28"};